import { callZpayFunction } from '../../callZpayFunction';

// 현재 화면 네비게이션 타이틀 변경
export const setTitle = (title: string) => {
  callZpayFunction('setTitle')({ title });
};
